import React, {Component} from "react";
import {Route, Switch, withRouter} from "react-router-dom";
import Button from "../Button";
import styled from "styled-components";

const Span = styled.span`
    padding-left : 10px;
    padding-right: 15px;

`;
const Exit = styled.div`
    width: 145px;
`;

class ExitButton extends Component{
    constructor(props) {
        super(props);
        this.handleExit = this.handleExit.bind(this);

    }
    /**
     * Exit AssetTask and set to "Release".
     */
    async handleExit() {
        const {match} = this.props;
        this.props.history.push(`/dashboard/${this.props.status}`);

    }
    render() {
        return (
            <Exit
                id={'dashboardBtn'}>
                <Button
                    onClickHandler={this.handleExit.bind(this)}>
                    <Span> Dashboard </Span></Button>
            </Exit>
        ) }
}
export default withRouter(ExitButton);